webpackJsonp([57490047887898],{

/***/ 872:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/cv.947ad305.png";

/***/ }),

/***/ 909:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/aleandri.d17af9d2.png";

/***/ }),

/***/ 910:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/poliba.2487cc7f.png";

/***/ }),

/***/ 911:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/rose.3dbdf22c.png";

/***/ }),

/***/ 912:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/uc.1bbabb23.png";

/***/ }),

/***/ 913:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/ucl.9474864c.jpg";

/***/ }),

/***/ 914:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/upm.11975399.gif";

/***/ }),

/***/ 916:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/robertogentile.5ad1df9b.png";

/***/ }),

/***/ 917:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij4KICAgIDxwYXRoIGQ9Ik0xNi41OSA4LjU5TDEyIDEzLjE3IDcuNDEgOC41OSA2IDEwbDYgNiA2LTZ6Ii8+CiAgICA8cGF0aCBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIi8+Cjwvc3ZnPgo="

/***/ }),

/***/ 1130:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  border: none;\n  border-bottom: 1px solid #e0e0e0;\n  background-image: url(', ');\n  background-size: cover;\n  background-position: 20% 22%;\n  height: 280px;\n  @media (min-width: 768px) {\n    background-position: 60% center;\n    border: none;\n    height: 470px;\n  }\n  @media (min-width: 1400px) {\n    border: none;\n  }\n'], ['\n  border: none;\n  border-bottom: 1px solid #e0e0e0;\n  background-image: url(', ');\n  background-size: cover;\n  background-position: 20% 22%;\n  height: 280px;\n  @media (min-width: 768px) {\n    background-position: 60% center;\n    border: none;\n    height: 470px;\n  }\n  @media (min-width: 1400px) {\n    border: none;\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  background-image: url(', ');\n  background-size: 100%;\n  @media (max-width: 599px) {\n    background-position: center;\n    background-repeat: no-repeat;\n    background-size: contain;\n    height: 150px;\n  }\n  @media (min-width: 600px) {\n    background-position: center;\n    background-repeat: no-repeat;\n    background-size: contain;\n    height: 200px;\n  }\n'], ['\n  background-image: url(', ');\n  background-size: 100%;\n  @media (max-width: 599px) {\n    background-position: center;\n    background-repeat: no-repeat;\n    background-size: contain;\n    height: 150px;\n  }\n  @media (min-width: 600px) {\n    background-position: center;\n    background-repeat: no-repeat;\n    background-size: contain;\n    height: 200px;\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _HeadlineWithFocus = __webpack_require__(6);
	
	var _HeadlineWithFocus2 = _interopRequireDefault(_HeadlineWithFocus);
	
	var _styledComponents = __webpack_require__(8);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _hedron = __webpack_require__(10);
	
	var _colorbar = __webpack_require__(12);
	
	var _colorbar2 = _interopRequireDefault(_colorbar);
	
	var _robertogentile = __webpack_require__(916);
	
	var _robertogentile2 = _interopRequireDefault(_robertogentile);
	
	var _triangle = __webpack_require__(917);
	
	var _triangle2 = _interopRequireDefault(_triangle);
	
	var _poliba = __webpack_require__(910);
	
	var _poliba2 = _interopRequireDefault(_poliba);
	
	var _upm = __webpack_require__(914);
	
	var _upm2 = _interopRequireDefault(_upm);
	
	var _uc = __webpack_require__(912);
	
	var _uc2 = _interopRequireDefault(_uc);
	
	var _ucl = __webpack_require__(913);
	
	var _ucl2 = _interopRequireDefault(_ucl);
	
	var _rose = __webpack_require__(911);
	
	var _rose2 = _interopRequireDefault(_rose);
	
	var _aleandri = __webpack_require__(909);
	
	var _aleandri2 = _interopRequireDefault(_aleandri);
	
	var _reactScrollableAnchor = __webpack_require__(18);
	
	var _reactScrollableAnchor2 = _interopRequireDefault(_reactScrollableAnchor);
	
	var _MainFooter = __webpack_require__(31);
	
	var _MainFooter2 = _interopRequireDefault(_MainFooter);
	
	var _cv = __webpack_require__(872);
	
	var _cv2 = _interopRequireDefault(_cv);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var ProfileImageWrapper = _styledComponents2.default.div(_templateObject, _robertogentile2.default);
	
	var ImageWrapper = _styledComponents2.default.div.attrs({
	
	  image: function image(props) {
	    return props.image;
	  }
	})(_templateObject2, function (props) {
	  return props.image;
	});
	
	var ImgColStyle = {
	  padding: '0'
	};
	
	var RowStyleEVEN = {
	  background: '#F9F9F9'
	};
	
	var RowStyleODD = {
	  background: '#F5F5F5'
	};
	
	var About = function About(props) {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'div',
	      { style: { height: '100%', verticalAlign: 'center', marginTop: '5%' } },
	      _react2.default.createElement(
	        _hedron.Row,
	        { alignItems: 'flex-end', style: { margin: '0' } },
	        _react2.default.createElement(
	          _hedron.Column,
	          { xs: 12, sm: 12, smShift: 0, md: 6, lg: 3, lgShift: 2 },
	          _react2.default.createElement(ProfileImageWrapper, null)
	        ),
	        _react2.default.createElement(
	          _hedron.Column,
	          { xs: 12, sm: 12, smShift: 0, md: 6, lg: 4, style: { background: '#F9F9F9' } },
	          _react2.default.createElement(
	            'h2',
	            null,
	            'About'
	          ),
	          _react2.default.createElement(_colorbar2.default, { color: '#A661C2' }),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              'strong',
	              null,
	              'Ciao, sono Rob. Sono un ingegnere sismico/strutturale e vivo a Londra.'
	            )
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Nel corso del dottorato al Politecnico di Bari ho scoperto la mia passione nel risolvere problemi ingegneristici programmando.'
	          ),
	          _react2.default.createElement(
	            'p',
	            { style: { marginBottom: 0 } },
	            'Presto ho cominicato a scrivere piccole app desktop per condividere quegli algoritmi, soprattutto con chi non scrive codice. Attualmente lavoro come Assistant Professor (Lecturer) alla University College London e consulente per progetti strutturali/modellazione numerica.'
	          ),
	          _react2.default.createElement(
	            'p',
	            { style: { marginLeft: '35%' } },
	            _react2.default.createElement(
	              'a',
	              { href: '#curriculum', style: { border: '0' } },
	              _react2.default.createElement('img', { style: { width: '30%', height: '30%' }, src: _cv2.default, alt: 'Check my CV' })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _hedron.Column,
	          null,
	          _react2.default.createElement(_MainFooter2.default, null)
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _reactScrollableAnchor2.default,
	      { id: 'curriculum' },
	      _react2.default.createElement(
	        'h2',
	        null,
	        'Breve CV'
	      )
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Esperienza lavorativa'
	    ),
	    _react2.default.createElement(
	      _hedron.Row,
	      { alignItems: 'center', style: RowStyleODD },
	      _react2.default.createElement(
	        _hedron.Column,
	        { xs: 12, sm: 4, smShift: 0, md: 3, lg: 2, style: ImgColStyle },
	        _react2.default.createElement(ImageWrapper, { image: _ucl2.default })
	      ),
	      _react2.default.createElement(
	        _hedron.Column,
	        { xs: 12, sm: 8, smShift: 0, md: 9, lg: 10 },
	        _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement(
	            'h3',
	            null,
	            'Assistant Professor (Lecturer) in Catastrophe Risk Modelling'
	          ),
	          'University College of London, London, United Kingdom. Gennaio 2022 - Present'
	        ),
	        _react2.default.createElement(
	          'ul',
	          null,
	          _react2.default.createElement(
	            'li',
	            null,
	            'Institute for Risk and Disaster Reduction (IRDR)'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Admission tutor per i programmi di master in IRDR'
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _hedron.Row,
	      { alignItems: 'center', style: RowStyleODD },
	      _react2.default.createElement(
	        _hedron.Column,
	        { xs: 12, sm: 4, smShift: 0, md: 3, lg: 2, style: ImgColStyle },
	        _react2.default.createElement(ImageWrapper, { image: _ucl2.default })
	      ),
	      _react2.default.createElement(
	        _hedron.Column,
	        { xs: 12, sm: 8, smShift: 0, md: 9, lg: 10 },
	        _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement(
	            'h3',
	            null,
	            'Marie Curie Senior Research Fellow'
	          ),
	          'University College of London, London, United Kingdom. Novembre 2019 - Dicembre 2021'
	        ),
	        _react2.default.createElement(
	          'ul',
	          null,
	          _react2.default.createElement(
	            'li',
	            null,
	            'Individual fellowship "MULTIRES: MULTI-level framework to enhance seismic RESilience of RC buildings"'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            '\u20AC212,934 finanziamento europeo'
	          )
	        ),
	        'Advisor: prof. Carmine Galasso'
	      )
	    ),
	    _react2.default.createElement(
	      _hedron.Row,
	      { alignItems: 'center', style: RowStyleODD },
	      _react2.default.createElement(
	        _hedron.Column,
	        { xs: 12, sm: 4, smShift: 0, md: 3, lg: 2, style: ImgColStyle },
	        _react2.default.createElement(ImageWrapper, { image: _ucl2.default })
	      ),
	      _react2.default.createElement(
	        _hedron.Column,
	        { xs: 12, sm: 8, smShift: 0, md: 9, lg: 10 },
	        _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement(
	            'h3',
	            null,
	            'Research Fellow'
	          ),
	          'University College of London, Londra, Regno Unito. Giugno 2018 - Ottobre 2019'
	        ),
	        _react2.default.createElement(
	          'ul',
	          null,
	          _react2.default.createElement(
	            'li',
	            null,
	            'Partecipazione al progetto di ricerca "INSPIRE: INdonesia School Programme to Increase REsilience"'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Assessment del rischio sismico: analisi di fragilit\xE0 e perdite'
	          )
	        ),
	        'Advisor: prof. Carmine Galasso'
	      )
	    ),
	    _react2.default.createElement(
	      _hedron.Row,
	      { alignItems: 'center', style: RowStyleEVEN },
	      _react2.default.createElement(
	        _hedron.Column,
	        { xs: 12, sm: 4, smShift: 0, md: 3, lg: 2, style: ImgColStyle },
	        _react2.default.createElement(ImageWrapper, { image: _poliba2.default })
	      ),
	      _react2.default.createElement(
	        _hedron.Column,
	        { xs: 12, sm: 8, smShift: 0, md: 9, lg: 10 },
	        _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement(
	            'h3',
	            null,
	            'Research collaborator ed esperto della materia (progetto di ponti)'
	          ),
	          'Politecnico di Bari. Febbraio 2018 - Maggio 2018'
	        ),
	        _react2.default.createElement(
	          'ul',
	          null,
	          _react2.default.createElement(
	            'li',
	            null,
	            'Ricerca nell\'ambito della valutazione sismica di edifici e ponti esistenti in CA'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Lezioni per il corso "Teoria e progetto di ponti". 50 studenti, 40 ore'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Supervisione di tesi magistrali. 13 studenti, fino ad ora'
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _hedron.Row,
	      { alignItems: 'center', style: RowStyleODD },
	      _react2.default.createElement(
	        _hedron.Column,
	        { xs: 12, sm: 4, smShift: 0, md: 3, lg: 2, style: ImgColStyle },
	        _react2.default.createElement(ImageWrapper, { image: _uc2.default })
	      ),
	      _react2.default.createElement(
	        _hedron.Column,
	        { xs: 12, sm: 8, smShift: 0, md: 9, lg: 10 },
	        _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement(
	            'h3',
	            null,
	            'Visiting researcher: gruppo di ricerca "SAFER & Sustainable"'
	          ),
	          'University of Canterbury, Christchurch, Nuova Zelanda. Settembre 2016 - Febbraio 2017'
	        ),
	        _react2.default.createElement(
	          'ul',
	          null,
	          _react2.default.createElement(
	            'li',
	            null,
	            'Partecipazione al gruppo di lavoro per la bozza delle linee guida per l\'assessment sismico della New Zealand Society for Earthquake Engineering (capitolo edifici in CA)'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Assessment sismico di edifici esistenti in CA: capacit\xE0 residua e casi studio reali'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Partecipazione ai sopralluoghi dopo il terremoto di Kaikoura 2016 (Magnitudo 7.8)'
	          )
	        ),
	        'Advisor: prof. Stefano Pampanin'
	      )
	    ),
	    _react2.default.createElement(
	      _hedron.Row,
	      { alignItems: 'center', style: RowStyleEVEN },
	      _react2.default.createElement(
	        _hedron.Column,
	        { xs: 12, sm: 4, smShift: 0, md: 3, lg: 2, style: ImgColStyle },
	        _react2.default.createElement(ImageWrapper, { image: _uc2.default })
	      ),
	      _react2.default.createElement(
	        _hedron.Column,
	        { xs: 12, sm: 8, smShift: 0, md: 9, lg: 10 },
	        _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement(
	            'h3',
	            null,
	            'Visiting researcher: gruppo di ricerca "SAFER"'
	          ),
	          'University of Canterbury, Christchurch, Nuova Zelanda. Novembre 2015 -- Febbraio 2016'
	        ),
	        _react2.default.createElement(
	          'ul',
	          null,
	          _react2.default.createElement(
	            'li',
	            null,
	            'Assessment sismico di edifici esistenti in CA: casi studio reali soggetti a recenti terremoti'
	          )
	        ),
	        'Advisor: prof. Stefano Pampanin'
	      )
	    ),
	    _react2.default.createElement(
	      _hedron.Row,
	      { alignItems: 'center', style: RowStyleODD },
	      _react2.default.createElement(
	        _hedron.Column,
	        { xs: 12, sm: 4, smShift: 0, md: 3, lg: 2, style: ImgColStyle },
	        _react2.default.createElement(ImageWrapper, { image: _aleandri2.default })
	      ),
	      _react2.default.createElement(
	        _hedron.Column,
	        { xs: 12, sm: 8, smShift: 0, md: 9, lg: 10 },
	        _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement(
	            'h3',
	            null,
	            'Tirocinio'
	          ),
	          'Aleandri S.p.A., Bari. Settembre 2014 - Novembre 2014'
	        ),
	        _react2.default.createElement(
	          'ul',
	          null,
	          _react2.default.createElement(
	            'li',
	            null,
	            'Modello 3D di una trave precompressa in CA per la sua analisi duante le fasi di costruzione. Alcune delle fasi di costruzione sono state migliorate basandosi sui risultati ottenuti'
	          )
	        ),
	        'Advisor: ing. Biagio Guido'
	      )
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Formazione'
	    ),
	    _react2.default.createElement(
	      _hedron.Row,
	      { alignItems: 'center', style: RowStyleODD },
	      _react2.default.createElement(
	        _hedron.Column,
	        { xs: 12, sm: 4, smShift: 0, md: 3, lg: 2, style: ImgColStyle },
	        _react2.default.createElement(ImageWrapper, { image: _poliba2.default })
	      ),
	      _react2.default.createElement(
	        _hedron.Column,
	        { xs: 12, sm: 8, smShift: 0, md: 9, lg: 10 },
	        _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement(
	            'h3',
	            null,
	            'Dottorato di ricerca, ingegneria sismica'
	          ),
	          'Politecnico di Bari, Gennaio 2018, dottorato con lode'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement(
	            'b',
	            null,
	            'Tesi'
	          ),
	          _react2.default.createElement('br', null),
	          'Estensione, miglioramento e validazione del Simple Lateral Mechanism \\\\ Analysis (SLaMA) per l\'assessment sismico di strutture esistenti in CA'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement(
	            'b',
	            null,
	            'Tutor'
	          ),
	          _react2.default.createElement('br', null),
	          'prof. Giuseppina Uva, prof. Domenico Raffaele, prof. Stefano Pampanin'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _hedron.Row,
	      { alignItems: 'center', style: RowStyleEVEN },
	      _react2.default.createElement(
	        _hedron.Column,
	        { xs: 12, sm: 4, smShift: 0, md: 3, lg: 2, style: ImgColStyle },
	        _react2.default.createElement(ImageWrapper, { image: _poliba2.default })
	      ),
	      _react2.default.createElement(
	        _hedron.Column,
	        { xs: 12, sm: 8, smShift: 0, md: 9, lg: 10 },
	        _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement(
	            'h3',
	            null,
	            'Laurea specialistica, ingegneria edile'
	          ),
	          'Politecnico di Bari, Ottobre 2014, 110 e lode'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement(
	            'b',
	            null,
	            'Tesi'
	          ),
	          _react2.default.createElement('br', null),
	          'Analisi parametrica di capacit\xE0 per pile mofusto in CA a sezione circolare'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Advisor: prof. Domenico Raffaele'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _hedron.Row,
	      { alignItems: 'center', style: RowStyleODD },
	      _react2.default.createElement(
	        _hedron.Column,
	        { xs: 12, sm: 4, smShift: 0, md: 3, lg: 2, style: ImgColStyle },
	        _react2.default.createElement(ImageWrapper, { image: _upm2.default })
	      ),
	      _react2.default.createElement(
	        _hedron.Column,
	        { xs: 12, sm: 8, smShift: 0, md: 9, lg: 10 },
	        _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement(
	            'h3',
	            null,
	            'Erasmus'
	          ),
	          'Universidad Politecnica de Madrid, Febrraio-Luglio 2013'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Advisor: prof. Pilar Izquierdo'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _hedron.Row,
	      { alignItems: 'center', style: RowStyleEVEN },
	      _react2.default.createElement(
	        _hedron.Column,
	        { xs: 12, sm: 4, smShift: 0, md: 3, lg: 2, style: ImgColStyle },
	        _react2.default.createElement(ImageWrapper, { image: _poliba2.default })
	      ),
	      _react2.default.createElement(
	        _hedron.Column,
	        { xs: 12, sm: 8, smShift: 0, md: 9, lg: 10 },
	        _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement(
	            'h3',
	            null,
	            'Laurea triennale, ingegneria edile'
	          ),
	          'Politecnico di Bari, Novembre 2012, 110 e lode'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement(
	            'b',
	            null,
	            'Tesi'
	          ),
	          _react2.default.createElement('br', null),
	          'Resistenza a taglio di travi in cemento armato con aggregati riciclati'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Advisor: prof. Mariella Diaferio'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _hedron.Row,
	      { alignItems: 'center', style: RowStyleODD },
	      _react2.default.createElement(
	        _hedron.Column,
	        { xs: 12, sm: 4, smShift: 0, md: 3, lg: 2, style: ImgColStyle },
	        _react2.default.createElement(ImageWrapper, { image: _rose2.default })
	      ),
	      _react2.default.createElement(
	        _hedron.Column,
	        { xs: 12, sm: 8, smShift: 0, md: 9, lg: 10 },
	        _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement(
	            'h3',
	            null,
	            'Corso singolo'
	          ),
	          'ROSE School (IUSS), Pavia. '
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement(
	            'b',
	            null,
	            'Titolo del Corso'
	          ),
	          _react2.default.createElement('br', null),
	          'Seismic design of low damage concrete and timber structures (160 hours)'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'prof. Stefano Pampanin'
	        )
	      )
	    )
	  );
	};
	
	exports.default = About;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-about-it-jsx-e2f041522d06fb558a08.js